<mat-card>
  <mat-card-title>Lateral Control Simulations</mat-card-title>

  <mat-card-subtitle>
    The lateral control simulations show the application of several lateral control algorithms to a single autonomous
    car, to highlight the difference of behavior between the different strategies.
  </mat-card-subtitle>

  <mat-card-content>
    <mat-form-field>
      <mat-label>Control Strategy</mat-label>
      <mat-select [(ngModel)]="selectedStrategy" (selectionChange)="updateStrategy()">
        <mat-option *ngFor="let strategy of strategies" [value]="strategy.value">{{strategy.viewValue}}</mat-option>
      </mat-select>
    </mat-form-field>
    &nbsp;
    <mat-slide-toggle color="primary" [(ngModel)]="simulatedPositionError" (change)="updateErrors()"
      matTooltip="The perceived position will be within a 0.1m radius of the real position" matTooltipPosition="below">
      Simulated position error
    </mat-slide-toggle>
    &nbsp;
    <mat-slide-toggle color="primary" [(ngModel)]="simulatedDirectionError" (change)="updateErrors()"
                      matTooltip="The perceived direction will be rotated by a random angle of the range [-0.1, 0.1]" matTooltipPosition="below">
      Simulated direction error
    </mat-slide-toggle>
    &nbsp;
    <mat-slide-toggle color="primary" [(ngModel)]="simulatedLatency" (change)="updateErrors()"
                      matTooltip="Commands will be applied with a delay of 400ms" matTooltipPosition="below">
      Simulated latency
    </mat-slide-toggle>
    &nbsp;
    <mat-form-field>
      <mat-label>Speed (m/s)</mat-label>
      <input matInput type="number" [(ngModel)]="speed" (change)="updateSpeed()" />
    </mat-form-field>

    <br />
    <button mat-stroked-button color="primary" (click)="showCustomCommandPopup()">Propose a custom command</button>
    &nbsp;
    <button mat-stroked-button color="primary" (click)="exportMeasures()">Export measures</button>
  </mat-card-content>

  <div #sizer style="width: 100%"></div>

  <canvas #canvasElement id="sim-view-js-canvas" [width]="sizer.offsetWidth" height="340"></canvas>

  <canvas #chartElement id="chart" height="340" [width]="sizer.offsetWidth" style="height: 340px;"></canvas>
</mat-card>
